import menu_alt_01 from './menu-alt-01.svg';
import menu_alt_02 from './menu-alt-02.svg';
import menu_alt_03 from './menu-alt-03.svg';
import menu_alt_04 from './menu-alt-04.svg';
import menu_alt_05 from './menu-alt-05.svg';
import menu_close_lg from './menu-close-lg.svg';
import menu_close_md from './menu-close-md.svg';
import menu_close_sm from './menu-close-sm.svg';
import menu_duo_lg from './menu-duo-lg.svg';
import menu_duo_md from './menu-duo-md.svg';
import menu_hamburger_lg from './menu-hamburger-lg.svg';
import menu_hamburger_md from './menu-hamburger-md.svg';
import menu_more_grid_big from './menu-more-grid-big.svg';
import menu_more_grid_small from './menu-more-grid-small.svg';
import menu_more_horizontal from './menu-more-horizontal.svg';
import menu_more_vertical from './menu-more-vertical.svg';

export const V2_MENU_ICONS: { [char: string]: string } = {
  menu_alt_01,
  menu_alt_02,
  menu_alt_03,
  menu_alt_04,
  menu_alt_05,
  menu_close_lg,
  menu_close_md,
  menu_close_sm,
  menu_duo_lg,
  menu_duo_md,
  menu_hamburger_lg,
  menu_hamburger_md,
  menu_more_grid_big,
  menu_more_grid_small,
  menu_more_horizontal,
  menu_more_vertical,
};

export const V2_MENU_ICON_NAMES: string[] = Object.keys(V2_MENU_ICONS);
